import { PiArrowLeftBold } from 'react-icons/pi';
import { Button } from '@ewf/components/Button';
import { SunkenBox } from '@ewf/components/SunkenBox';
import { CopyAddressButton } from '@ewf/components/ModalUI/CopyAddressButton';
import { Stepper } from '@ewf/components/ModalUI/Stepper';
import { TransactionProgress } from '@ewf/components/ModalUI/TransactionProgress';
import { CloseButton } from '@ewf/components/ModalUI/CloseButton';
import { displayBalance, formatGasFee } from '@ewf/utils/balance-helpers';
import { getNativeTokenSymbol } from '@ewf/lib/utils';

export const Confirm = ({
  fee,
  address = '',
  amount,
  symbol = 'stEWT',
  onConfirm,
  onGoBack,
  onClose,
}: Props): JSX.Element => {
  return (
    <div className="w-[550px] rounded-lg border-2 border-transparent p-8 gradient-border-secondary-with-gray-90">
      <section className="relative mb-8 flex h-[40px] justify-between">
        <button
          onClick={onGoBack}
          className="grid h-[40px] w-[40px] place-items-center rounded-full bg-gray-100 text-font hover:bg-gray-95 active:bg-black"
        >
          <PiArrowLeftBold size={24} />
        </button>
        <CopyAddressButton address={address} />
        <CloseButton onClick={onClose} />
      </section>
      <section className="mb-8">
        <Stepper step={2} maxStep={2} />
      </section>
      <section className="mb-8 rounded-lg p-6 bg-popup-gradient">
        <TransactionProgress operation="claim-reward" step="confirm" />
        <SunkenBox className="mb-4 text-center font-bold">Confirm transaction</SunkenBox>
        <SunkenBox className="text-center font-bold">
          <h2 className="mb-2 font-primary">
            {displayBalance(amount)} {symbol}
          </h2>
          <p className="text-sm uppercase text-font-subtle">Claim Reward Amount</p>
        </SunkenBox>
      </section>
      <section className="mb-8 flex justify-between rounded-lg p-6 bg-popup-gradient">
        <p>Gas fees</p>
        <p>
          {(() => {
            const formatted = formatGasFee(fee, getNativeTokenSymbol());
            return `${formatted.value} ${formatted.unit}`;
          })()}
        </p>
      </section>
      <section className="flex justify-center">
        <Button onClick={onConfirm}>Confirm</Button>
      </section>
    </div>
  );
};

interface Props {
  fee: number;
  address: string;
  amount: string;
  symbol?: string;
  onConfirm: () => void;
  onGoBack: () => void;
  onClose: () => void;
}
